import * as React from "react";
import { Route } from "react-router";
import uuid from "uuid-v4";
import { ProfileEdit } from "./layout/profile";
import { UserList, UserShow, UserCreate, UserEdit } from "./users";
import { Admin, Resource } from "react-admin";
import {
  FirebaseDataProvider,
  FirebaseAuthProvider,
} from "react-admin-firebase";
import firebase from "firebase";
import UserIcon from "@material-ui/icons/People";

import { firebaseConfig } from "./FIREBASE_CONFIG";
import Welcome from "./Welcome";
import { Layout, Menu } from "./layout";
//import CustomLoginPage from "./CustomLoginPage";
import BeautifulLogin from "./components/login/widget/BeautifulLogin";
import { JobList, JobCreate, JobEdit } from "./jobs";
import { ContactList, ContactCreate, ContactEdit } from "./contacts";
import {
  NewsletterList,
  NewsletterCreate,
  NewsletterEdit,
} from "./newsletters";
import { CandidateList, CandidateCreate, CandidateEdit } from "./candidates";
import {
  ConfigAdminList as ConfigAdminPhasesList,
  ConfigAdminCreate as ConfigAdminPhasesCreate,
  ConfigAdminEdit as ConfigAdminPhasesEdit,
} from "./configAdmin";
import {
  ConfigAdminList as ConfigAdminAreasList,
  ConfigAdminCreate as ConfigAdminAreasCreate,
  ConfigAdminEdit as ConfigAdminAreasEdit,
} from "./configAdmin";
import {
  ConfigAdminList as ConfigAdminPositionsList,
  ConfigAdminCreate as ConfigAdminPositionsCreate,
  ConfigAdminEdit as ConfigAdminPositionsEdit,
} from "./configAdmin";
import {
  ConfigAdminList as ConfigAdminCountriesList,
  ConfigAdminCreate as ConfigAdminCountriesCreate,
  ConfigAdminEdit as ConfigAdminCountriesEdit,
} from "./configAdmin";
import {
  OngoingProjectList,
  OngoingProjectListAdmin,
  OngoingProjectShow,
  OngoingProjectCreate,
  OngoingProjectEdit,
} from "./ongoingProjects";
import {
  PotentialProjectList,
  PotentialProjectListAdmin,
  PotentialProjectShow,
  PotentialProjectCreate,
  PotentialProjectEdit,
} from "./potentialProjects";

const actionCodeSettings = {
  url: "https://admin.logicaljupiter.eu/login",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const authProvider = FirebaseAuthProvider(firebaseConfig);

const myAuthProvider = {
  ...authProvider,
  getPermissions: async () => {
    const res = await authProvider.checkAuth();
    const myUser = await dataProvider.getOne("users", { id: res.uid || "" });
    const isAdmin = myUser.data.isAdmin || false;
    return isAdmin ? "admin" : "user";
  },
  getIdentity: async () => {
    const res = await authProvider.checkAuth();
    const myUser = await dataProvider.getOne("users", { id: res.uid || "" });
    if (myUser.data) {
      return {
        ...myUser.data,
        fullName: myUser.data.firstname,
        avatar: myUser.data.photo.src,
      };
    }
    return;
  },
};

const dataProvider = FirebaseDataProvider(firebaseConfig, {
  logging: true,
  app: firebaseApp,
  persistence: "local",
  dontAddIdFieldToDoc: true,
  lazyLoading: {
    enabled: true,
  },
  firestoreCostsLogger: {
    enabled: true,
  },
});

const myDataProvider = {
  ...dataProvider,
  getUserProfile: async () => {
    const res = await authProvider.checkAuth();
    const myUser = await dataProvider.getOne("users", { id: res.uid || "" });
    if (myUser.data) {
      return myUser.data;
    }
    return;
  },
  updateUserProfile: async ({ data }) => {
    const { vacations, photo, id } = data;
    const params = {
      data: { vacations: vacations, photo: photo },
      id: id,
    };
    const res = await dataProvider.update("users", params);
    return { data: res.data };
  },
  create: async (resource, params) => {
    if (resource === "users") {
      const auth = firebase.auth();
      const resFirebase = await auth.createUserWithEmailAndPassword(
        params.data.email, 
        uuid()
      );
      const res = await dataProvider.create(resource, {
        data: { ...params.data, id: resFirebase.user.uid },
      });
      await auth.sendPasswordResetEmail(params.data.email, actionCodeSettings);
      return { data: res.data };
    } else {
      const res = await dataProvider.create(resource, params);
      return { data: res.data };
    }
  },

  getList: async (resource, params) => {
    const page = params.pagination.page;
    const perPage = params.pagination.perPage;
    const myList = await dataProvider.getList(resource, {
      ...params,
      filter: {},
      pagination: { page: 1, perPage: 900 },
    });
    const myKey = Object.keys(params.filter)[0];
    const myFilter = myKey
      ? myList.data.filter(
          (item) =>
            item[myKey]
              .toLowerCase()
              .indexOf(params.filter[myKey].toLowerCase()) > -1
        )
      : myList.data;
    return {
      data: myFilter.slice((page - 1) * perPage, page * perPage),
      total: myFilter.length,
    };
  },
};

const App = () => {
  return (
    <Admin
      loginPage={BeautifulLogin}
      dataProvider={myDataProvider}
      authProvider={myAuthProvider}
      appLayout={Layout}
      menu={Menu}
      dashboard={Welcome}
      customRoutes={[
        <Route
          key="my-profile"
          path="/my-profile"
          render={() => <ProfileEdit />}
        />,
      ]}
      //layout={Layout}
    >
      {(permissions) => [
        <Resource
          name="candidates"
          list={CandidateList}
          create={CandidateCreate}
          edit={CandidateEdit}
        />,
        <Resource
          name="contacts"
          list={ContactList}
          create={ContactCreate}
          edit={ContactEdit}
        />,
        <Resource
          name={"jobs"}
          list={JobList}
          //show={JobShow}
          create={permissions === "admin" ? JobCreate : null}
          edit={permissions === "admin" ? JobEdit : null}
        />,
        <Resource
          name="positions"
          list={ConfigAdminPositionsList}
          create={ConfigAdminPositionsCreate}
          edit={ConfigAdminPositionsEdit}
        />,
        <Resource
          name="ongoingProjects"
          options={{ label: "Ongoing Projects" }}
          list={
            permissions === "admin"
              ? OngoingProjectListAdmin
              : OngoingProjectList
          }
          show={OngoingProjectShow}
          create={permissions === "admin" ? OngoingProjectCreate : null}
          edit={permissions === "admin" ? OngoingProjectEdit : null}
        />,
        <Resource
          name="potentialProjects"
          options={{ label: "Potential Projects" }}
          list={
            permissions === "admin"
              ? PotentialProjectListAdmin
              : PotentialProjectList
          }
          show={PotentialProjectShow}
          create={permissions === "admin" ? PotentialProjectCreate : null}
          edit={permissions === "admin" ? PotentialProjectEdit : null}
        />,
        <Resource
          name="users"
          icon={UserIcon}
          list={UserList}
          show={UserShow}
          create={UserCreate}
          edit={UserEdit}
        />,
        <Resource
          name="newsletters"
          list={NewsletterList}
          create={NewsletterCreate}
          edit={NewsletterEdit}
        />,
        <Resource
          name="areas"
          list={ConfigAdminAreasList}
          create={ConfigAdminAreasCreate}
          edit={ConfigAdminAreasEdit}
        />,
        <Resource
          name="phases"
          list={ConfigAdminPhasesList}
          create={ConfigAdminPhasesCreate}
          edit={ConfigAdminPhasesEdit}
        />,
        <Resource
          name="countries"
          list={ConfigAdminCountriesList}
          create={ConfigAdminCountriesCreate}
          edit={ConfigAdminCountriesEdit}
        />,
        <Resource
          name="positions"
          list={ConfigAdminPositionsList}
          create={ConfigAdminPositionsCreate}
          edit={ConfigAdminPositionsEdit}
        />,
        <Resource name="profile" />,
      ]}
    </Admin>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js